import {
  ContactsOutlined,
  DashboardOutlined,
  DeleteOutlined,
  FileDoneOutlined,
  FilePdfOutlined,
  FormOutlined,
  SettingOutlined,
  SolutionOutlined,
  UsergroupAddOutlined,
  EnvironmentOutlined,
  UserOutlined,
  TeamOutlined,
  HomeOutlined,
  FieldTimeOutlined,
  CommentOutlined,
  ClearOutlined,
  SkinOutlined,
  ScheduleOutlined,
  EditOutlined,
  TrophyOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import { APP_PREFIX_PATH } from "configs/AppConfig";

// A module page's first-level tabs, shown in the page header (like Admin's
// sub-pages) and routed as /app/<module>/<tab>; the module's index.js maps
// each tab key to its screen.
// [key, title, options]; options.end puts the tab at the right end of the bar
const moduleTabs = (base, tabs) =>
  tabs.map(([key, title, options = {}]) => ({
    key: `${base}-${key}`,
    tabKey: key,
    path: `${APP_PREFIX_PATH}/${base}/${key}`,
    title,
    submenu: [],
    ...options,
  }));

const navigationConfig = [
  {
    key: "admin",
    title: "Admin",
    description: "Group, contacts, certificates, and settings.",
    icon: UserOutlined,
    section: "core",
    submenu: [
      {
        key: "dashboards",
        path: `${APP_PREFIX_PATH}/dashboards`,
        title: "Dashboard",
        icon: DashboardOutlined,
        submenu: [],
      },
      {
        key: "supplier-management",
        path: `${APP_PREFIX_PATH}/contact_detail`,
        title: "Supplier & Management",
        icon: ContactsOutlined,
        submenu: [],
      },
      {
        key: "business-insurance",
        path: `${APP_PREFIX_PATH}/business_insurance`,
        title: "Business Insurance",
        icon: FileDoneOutlined,
        submenu: [],
      },
      {
        key: "certificates",
        path: `${APP_PREFIX_PATH}/certificates`,
        title: "Certificates",
        icon: FilePdfOutlined,
        submenu: [],
      },
      {
        key: "statements",
        path: `${APP_PREFIX_PATH}/statements`,
        title: "Statements",
        icon: SolutionOutlined,
        submenu: [],
      },
      {
        key: "vehicle",
        path: `${APP_PREFIX_PATH}/vehicle`,
        title: "Vehicle",
        icon: FormOutlined,
        submenu: [],
      },
      {
        key: "settings",
        path: `${APP_PREFIX_PATH}/setting`,
        title: "Settings",
        icon: SettingOutlined,
        submenu: [],
      },
    ],
    type: ["A"],
  },
  {
    key: "workforce",
    title: "Workforce",
    description: "Staff directory, compliance documents and deleted staff.",
    icon: TeamOutlined,
    section: "core",
    submenu: [
      // People's own tabs, shown in the header like the other modules'.
      ...moduleTabs("hr-users", [
        ["staff-directory", "Staff Directory"],
        ["compliance", "Compliance"],
        ["deleted-users", "Deleted Staff", { end: true, icon: DeleteOutlined }],
      ]),
      /*{
        key: "staff-tracking",
        path: `${APP_PREFIX_PATH}/staff-tracking`,
        title: "Tracking",
        icon: EnvironmentOutlined,
        submenu: [],
        type: ["A"],
      },*/
      /*{
        key: "hr",
        path: `${APP_PREFIX_PATH}/staff`,
        title: "HR",
        icon: UsergroupAddOutlined,
        submenu: [],
        type: ["A"],
      },
      {
        key: "users",
        path: `${APP_PREFIX_PATH}/user-management`,
        title: "Users",
        icon: UserOutlined,
        submenu: [],
        type: ["A"],
      }*/

    ],
    type: ["A"],
  },
  {
    key: "facility",
    path: `${APP_PREFIX_PATH}/facility-portal`,
    title: "Facility",
    description: "Groups, facilities and contracted hours.",
    icon: HomeOutlined,
    submenu: moduleTabs("facility-portal", [
      ["group", "Group"],
      ["facility", "Facility"],
      ["contracted-hours", "Contracted Hours"],
    ]),
    type: ["A"],
    section: "core",
  },
  {
    key: "cleaning-audit",
    path: `${APP_PREFIX_PATH}/cleaning-audit`,
    title: "Cleaning Audit",
    description: "Facility cleaning audits, questions, and reports.",
    icon: ClearOutlined,
    submenu: moduleTabs("cleaning-audit", [
      ["dashboard", "Dashboard"],
      ["facility-setup", "Facility Setup"],
      ["questions", "Questions"],
      ["audits", "Audits"],
      ["reports", "Reports"],
    ]),
    type: ["A"],
    moduleId: "18",
    section: "operations",
  },
  {
    key: "laundry-audit",
    path: `${APP_PREFIX_PATH}/laundry-audit`,
    title: "Laundry Audit",
    description: "Facility laundry audits, questions, and reports.",
    icon: SkinOutlined,
    submenu: moduleTabs("laundry-audit", [
      ["dashboard", "Dashboard"],
      ["questions", "Questions"],
      ["audit-register", "Audit Register"],
      ["audit-tracking", "Audit Tracking"],
      ["reports", "Reports"],
    ]),
    type: ["A"],
    moduleId: "19",
    section: "operations",
  },
  {
    key: "work-scheduler",
    path: `${APP_PREFIX_PATH}/work-scheduler`,
    title: "Work Scheduler",
    description: "Periodicals, scheduling, and recurring facility work.",
    icon: ScheduleOutlined,
    submenu: moduleTabs("work-scheduler", [
      ["overview", "Overview"],
      ["periodical-master", "Periodical Master"],
      ["frequency-master", "Frequency Master"],
      ["allocation", "Allocation"],
      ["scheduling", "Scheduling"],
      ["periodical-report", "Report"],
      ["status-view", "Status View"],
    ]),
    type: ["A"],
    moduleId: "2",
    section: "operations",
  },
  {
    key: "employee-connect",
    path: `${APP_PREFIX_PATH}/employee-connect`,
    title: "Employee Connect",
    description: "Education, toolbox talks, memos, competencies, equipment, policies, compliance manuals, KPIs and surveys.",
    icon: EditOutlined,
    // Organised by subject; each subject has its tasks as in-page tabs.
    submenu: moduleTabs("employee-connect", [
      ["education", "Education"],
      ["toolbox", "Toolbox"],
      ["memos", "Memos"],
      ["competency", "Competency"],
      ["equipment", "Equipment"],
      ["policies", "Policies"],
      ["compliance-manual", "Compliance Manual"],
      ["kpi", "KPI"],
      ["survey", "Survey"],
    ]),
    type: ["A"],
    moduleId: "20",
    section: "operations",
  },
  {
    key: "workpulse",
    path: `${APP_PREFIX_PATH}/workpulse`,
    title: "Work Pulse",
    description: "Facility tablets, staff tokens, shifts and attendance tracking.",
    icon: FieldTimeOutlined,
    submenu: moduleTabs("workpulse", [
      ["facility-tablets", "Settings"],
      ["staff-tokens", "Staff"],
      ["roster", "Roster"],
      ["timesheet", "Timesheet"],
    ]),
    type: ["A"],
    section: "operations",
  },
  {
    key: "communication",
    path: `${APP_PREFIX_PATH}/communication-management`,
    title: "Communication",
    description: "Communication app logins for facilities and staff.",
    icon: CommentOutlined,
    submenu: [],
    type: ["A"],
    section: "operations",
  },
  {
    key: "cleaning-excellence",
    title: "Cleaning Excellence",
    icon: TrophyOutlined,
    submenu: [],
    type: ["A"],
    section: "connected",
    simpleExternal: true,
    managerAccess: true, // managers see it too (opens signed in when the module is assigned to them)
    urlEnvKey: "REACT_APP_URL_CLEANING_EXCELLENCE",
  },
  {
    key: "asepsis-loop",
    title: "Asepsis Loop",
    icon: SyncOutlined,
    submenu: [],
    type: ["A"],
    section: "connected",
    simpleExternal: true,
    managerAccess: true, // managers see it too (opens signed in when the module is assigned to them)
    urlEnvKey: "REACT_APP_URL_ASEPSIS_LOOP",
  },
  // Managers don't get the Admin entry, so they reach the Dashboard (limited
  // to their own facilities) through this one. Kept last so it does not
  // change where managers land or which entry admins' pages resolve to.
  {
    key: "manager-dashboard",
    path: `${APP_PREFIX_PATH}/dashboards`,
    title: "Dashboard",
    description: "Overview of the facilities you manage.",
    icon: DashboardOutlined,
    submenu: [],
    type: [],
    managerOnly: true,
    section: "core",
  },
];

export default navigationConfig;
